import { render, staticRenderFns } from "./AzDistributorsMetadataEditPanel.vue?vue&type=template&id=456f0f6a"
import script from "./AzDistributorsMetadataEditPanel.vue?vue&type=script&lang=js"
export * from "./AzDistributorsMetadataEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports